import React, { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import Select from 'react-select';
import Swal from 'sweetalert2';
import apiurl from '../Api';
import RefreshContext from './RefreshContext';


function LicenseRegistration() {
  const [activeTab, setActiveTab] = useState('client-contracts');
  const [userPost, setUserPost] = useState('');
  const { refreshKey } = useContext(RefreshContext);
    
  const [contracts, setContracts] = useState([]);
  const [loadingContracts, setLoadingContracts] = useState(false);
  const [contractsError, setContractsError] = useState('');
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showBulkResultModal, setShowBulkResultModal] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [savingInternal, setSavingInternal] = useState(false);
  const [savingEdit, setSavingEdit] = useState(false);
  const [fetchingClients, setFetchingClients] = useState(false);
  const [uploadingBulk, setUploadingBulk] = useState(false);
  const [bulkResultTabContracts, setBulkResultTabContracts] = useState('added');
  const [bulkUploadResult, setBulkUploadResult] = useState({
    inserted: 0,
    failed: 0,
    alreadyInDatabase: 0,
    addedRows: [],
    rejectedRows: [],
    alreadyRows: []
  });
  const [bulkFile, setBulkFile] = useState(null);
  const [externalClientOptions, setExternalClientOptions] = useState([]);
  const [selectedClientOption, setSelectedClientOption] = useState(null);
  const [selectedEditClientOption, setSelectedEditClientOption] = useState(null);
  const [lastExtractedAt, setLastExtractedAt] = useState('');
  const [editingId, setEditingId] = useState(0);

  const [addClientForm, setAddClientForm] = useState({
    clientName: '',
    clientId: '',
    contractName: '',
    contractNo: '',
    contractCode: '',
    startDate: '',
    endDate: '',
    anchorName: '',
    anchorEmailId: '',
    anchorMobileNo: ''
  });

  const [editForm, setEditForm] = useState({
    clientName: '',
    clientId: '',
    contractName: '',
    contractNo: '',
    contractCode: '',
    startDate: '',
    endDate: '',
    anchorName: '',
    anchorEmailId: '',
    anchorMobileNo: ''
  });

  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchInput, setSearchInput] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [complianceRows, setComplianceRows] = useState([]);
  const [loadingCompliance, setLoadingCompliance] = useState(false);
  const [complianceError, setComplianceError] = useState('');
  const [showAddComplianceModal, setShowAddComplianceModal] = useState(false);
  const [showEditComplianceModal, setShowEditComplianceModal] = useState(false);
  const [showComplianceBulkModal, setShowComplianceBulkModal] = useState(false);
  const [showComplianceBulkResultModal, setShowComplianceBulkResultModal] = useState(false);
  const [savingCompliance, setSavingCompliance] = useState(false);
  const [savingComplianceEdit, setSavingComplianceEdit] = useState(false);
  const [uploadingComplianceBulk, setUploadingComplianceBulk] = useState(false);
  const [complianceBulkFile, setComplianceBulkFile] = useState(null);
  const [complianceBulkResult, setComplianceBulkResult] = useState({
    inserted: 0,
    failed: 0,
    alreadyInDatabase: 0,
    addedRows: [],
    rejectedRows: [],
    alreadyRows: []
  });
  const [bulkResultTab, setBulkResultTab] = useState('added');
  const [editingComplianceId, setEditingComplianceId] = useState(0);
  const [compliancePage, setCompliancePage] = useState(1);
  const [complianceTotalPages, setComplianceTotalPages] = useState(0);
  const [complianceTotalRecords, setComplianceTotalRecords] = useState(0);
  const [complianceSearchInput, setComplianceSearchInput] = useState('');
  const [debouncedComplianceSearch, setDebouncedComplianceSearch] = useState('');
  const [complianceForm, setComplianceForm] = useState({
    companyName: '',
    licenseParticular: '',
    clientName: '',
    location: '',
    stateName: '',
    registrationNo: '',
    startDate: '',
    renewalDate: ''
  });
  const [complianceCompanyOptions, setComplianceCompanyOptions] = useState([]);
  const [selectedComplianceCompanyOption, setSelectedComplianceCompanyOption] = useState(null);
  const [editComplianceForm, setEditComplianceForm] = useState({
    companyName: '',
    licenseParticular: '',
    clientName: '',
    location: '',
    stateName: '',
    registrationNo: '',
    startDate: '',
    renewalDate: ''
  });

  const tabButtonBaseStyle = {
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    borderRadius: '0',
    fontWeight: 600,
    fontSize: '1.05rem',
    padding: '0.75rem 0.25rem',
    marginRight: '1.25rem'
  };
  const sectionHeadingStyle = {
    fontSize: '1.75rem',
    lineHeight: 1.2
  };
  const readOnlyInputStyle = {
    backgroundColor: '#f1f3f7',
    color: '#6c757d',
    cursor: 'not-allowed'
  };
  const editableDateStyle = {
    backgroundColor: '#eef7ff',
    borderColor: 'var(--primary-color)'
  };

  const formatLastExtracted = (value) => {
    if (!value) return 'Not fetched yet';
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return value;
    return dt.toLocaleString();
  };

  const parseFlexibleDate = (value) => {
    if (!value) return null;
    const text = String(value).trim();
    if (!text) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
      const [y, m, d] = text.split('-').map(Number);
      return new Date(y, m - 1, d, 23, 59, 59, 999);
    }
    const dt = new Date(text);
    if (Number.isNaN(dt.getTime())) return null;
    return dt;
  };

  const getExpiryHighlightStyle = (value) => {
    const target = parseFlexibleDate(value);
    if (!target) return {};
    const now = new Date();
    if (target.getTime() < now.getTime()) {
      return { backgroundColor: '#ffe5e5', color: '#a02828', fontWeight: 600 };
    }
    const twoMonthsLater = new Date(now);
    twoMonthsLater.setMonth(twoMonthsLater.getMonth() + 2);
    if (target.getTime() <= twoMonthsLater.getTime()) {
      return { backgroundColor: '#fff2df', color: '#a25900', fontWeight: 600 };
    }
    return {};
  };

  const fetchClientContracts = async (pageNo, sync = false, searchTerm = '') => {
    try {
      setLoadingContracts(true);
      setContractsError('');
      const q = encodeURIComponent(searchTerm || '');
      const response = await axios.get(
        `${apiurl}license_registration.php?list=client_contracts&page=${pageNo}&limit=${limit}&sync=${sync ? 1 : 0}&q=${q}`
      );

      if (response?.data?.status === true) {
        setContracts(response.data.data || []);
        setUserPost(response.data.userpost);
        setTotalPages(Number(response?.data?.pagination?.total_pages || 0));
        setTotalRecords(Number(response?.data?.pagination?.total_records || 0));
        setLastExtractedAt(response?.data?.last_extracted_at || '');
      } else {
        setContracts([]);
        setTotalPages(0);
        setTotalRecords(0);
        setContractsError(response?.data?.message || 'Failed to fetch client contracts');
      }
    } catch (error) {
      setContracts([]);
      setTotalPages(0);
      setTotalRecords(0);
      setContractsError('Failed to fetch client contracts');
    } finally {
      setLoadingContracts(false);
    }
  };

  // const fetchLoginPost = async () => {
  //   try {
  //     const response = await axios.get(`${apiurl}access.php?subdomain=react`);
  //     const post = String(response?.data?.loginpost || '').toLowerCase().trim();
  //     setUserPost(post);
  //   } catch (error) {
  //     setUserPost('');
  //   }
  // };

  const fetchExternalClients = async () => {
    try {
      const response = await axios.get(`${apiurl}license_registration.php?list=external_clients`);
      if (response?.data?.status === true) {
        const rows = response.data.data || [];
        setUserPost(response.data.userpost);
        setExternalClientOptions(
          rows.map((item) => ({
            value: item.staffinggo_client_id,
            label: item.client_name,
            clientName: item.client_name,
            clientId: item.staffinggo_client_id
          }))
        );
      } else {
        setExternalClientOptions([]);
      }
    } catch (error) {
      setExternalClientOptions([]);
    }
  };

  const fetchComplianceRecords = async (pageNo, searchTerm = '') => {
    try {
      setLoadingCompliance(true);
      setComplianceError('');
      const q = encodeURIComponent(searchTerm || '');
      const response = await axios.get(
        `${apiurl}license_registration.php?list=compliance_records&page=${pageNo}&limit=${limit}&q=${q}`
      );

      if (response?.data?.status === true) {
        setComplianceRows(response.data.data || []);
        setUserPost(response.data.userpost);
        setComplianceTotalPages(Number(response?.data?.pagination?.total_pages || 0));
        setComplianceTotalRecords(Number(response?.data?.pagination?.total_records || 0));
      } else {
        setComplianceRows([]);
        setComplianceTotalPages(0);
        setComplianceTotalRecords(0);
        setComplianceError(response?.data?.message || 'Failed to fetch compliance records');
      }
    } catch (error) {
      setComplianceRows([]);
      setComplianceTotalPages(0);
      setComplianceTotalRecords(0);
      setComplianceError('Failed to fetch compliance records');
    } finally {
      setLoadingCompliance(false);
    }
  };

  const fetchComplianceCompanies = async () => {
    try {
      const response = await axios.get(`${apiurl}license_registration.php?list=compliance_companies`);
      if (response?.data?.status === true) {
        setUserPost(response.data.userpost);
        const rows = Array.isArray(response?.data?.data) ? response.data.data : [];
        setComplianceCompanyOptions(
          rows.map((name) => ({
            value: name,
            label: name
          }))
        );
      } else {
        setComplianceCompanyOptions([]);
      }
    } catch (error) {
      setComplianceCompanyOptions([]);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput.trim());
      setPage(1);
    }, 450);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    fetchClientContracts(page, false, debouncedSearch);
  }, [page, debouncedSearch,refreshKey]);

  useEffect(() => {
    fetchExternalClients();
    //fetchLoginPost();
  }, [refreshKey]);

  const isComplianceManager = userPost=="compliance_manager";

  useEffect(() => {
    if (isComplianceManager) {
      setActiveTab('compliance');
    }
  }, [isComplianceManager,refreshKey]);

  useEffect(() => {
    if (activeTab !== 'compliance') return;
    fetchComplianceCompanies();
  }, [activeTab,refreshKey]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedComplianceSearch(complianceSearchInput.trim());
      setCompliancePage(1);
    }, 450);
    return () => clearTimeout(timer);
  }, [complianceSearchInput,refreshKey]);

  useEffect(() => {
    if (activeTab !== 'compliance') return;
    fetchComplianceRecords(compliancePage, debouncedComplianceSearch);
  }, [activeTab, compliancePage, debouncedComplianceSearch]);

  const changePage = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages || nextPage === page) return;
    setPage(nextPage);
  };

  const changeCompliancePage = (nextPage) => {
    if (nextPage < 1 || nextPage > complianceTotalPages || nextPage === compliancePage) return;
    setCompliancePage(nextPage);
  };

  const handleFetchClients = async () => {
    const confirm = await Swal.fire({
      title: 'Fetch latest clients?',
      text: 'This will sync latest external client contracts.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, fetch now',
      cancelButtonText: 'Cancel'
    });
    if (!confirm.isConfirmed) return;

    try {
      setFetchingClients(true);
      const targetPage = 1;
      setPage(targetPage);
      await fetchClientContracts(targetPage, true, debouncedSearch);
      await fetchExternalClients();
      await Swal.fire({
        icon: 'success',
        title: 'Done',
        text: 'Clients fetched and synced successfully.',
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      await Swal.fire('Error', 'Failed to fetch clients.', 'error');
    } finally {
      setFetchingClients(false);
    }
  };

  const handleAddClientInput = (e) => {
    const { name, value } = e.target;
    setAddClientForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const closeBulkModal = () => {
    setShowBulkModal(false);
    setBulkFile(null);
  };

  const closeBulkResultModal = () => {
    setShowBulkResultModal(false);
    setBulkResultTabContracts('added');
    setBulkUploadResult({
      inserted: 0,
      failed: 0,
      alreadyInDatabase: 0,
      addedRows: [],
      rejectedRows: [],
      alreadyRows: []
    });
  };

  const downloadDemoCsv = () => {
    const headers = [
      'client_id',
      'contract_name',
      'contract_no',
      'contract_code',
      'start_date',
      'end_date',
      'anchor_name',
      'anchor_email_id',
      'anchor_mobile_no'
    ];
    const sample = [
      '1693',
      'Internal Staffing Contract',
      'INT-UNI-001',
      'INTC/001',
      'YYYY-MM-DD',
      'YYYY-MM-DD',
      'Sample Anchor',
      'sample.anchor@meraqui.com',
      '9876543210'
    ];
    const csv = `${headers.join(',')}\n${sample.join(',')}\n`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'license_contracts_bulk_demo.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const downloadClientList = () => {
    if (!externalClientOptions.length) {
      Swal.fire('Warning', 'Client list is empty. Please fetch clients first.', 'warning');
      return;
    }

    const headers = ['client_id', 'client_name'];
    const rows = externalClientOptions.map((opt) => [opt.clientId, opt.clientName]);
    const csv = `${headers.join(',')}\n${rows.map((r) => `${r[0]},"${String(r[1] || '').replace(/"/g, '""')}"`).join('\n')}\n`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'client_list_for_bulk_upload.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleBulkUpload = async () => {
    if (!bulkFile) {
      await Swal.fire('Warning', 'Please select CSV file first.', 'warning');
      return;
    }

    const fileName = (bulkFile.name || '').toLowerCase();
    if (!fileName.endsWith('.csv')) {
      await Swal.fire('Error', 'Only CSV file is allowed.', 'error');
      return;
    }

    const confirm = await Swal.fire({
      title: 'Upload CSV?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, upload',
      cancelButtonText: 'Cancel'
    });
    if (!confirm.isConfirmed) return;

    const formData = new FormData();
    formData.append('action', 'bulk_upload_internal');
    formData.append('csv_file', bulkFile);

    try {
      setUploadingBulk(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status) {
        setBulkUploadResult({
          inserted: Number(response?.data?.inserted || 0),
          failed: Number(response?.data?.failed || 0),
          alreadyInDatabase: Number(response?.data?.already_in_database || 0),
          addedRows: Array.isArray(response?.data?.added_rows) ? response.data.added_rows : [],
          rejectedRows: Array.isArray(response?.data?.rejected_rows) ? response.data.rejected_rows : [],
          alreadyRows: Array.isArray(response?.data?.already_rows) ? response.data.already_rows : []
        });
        setBulkResultTabContracts('added');
        closeBulkModal();
        setShowBulkResultModal(true);
        setPage(1);
        await fetchClientContracts(1, false, debouncedSearch);
      } else {
        const msg = response?.data?.message || 'Bulk upload failed';
        const errs = Array.isArray(response?.data?.errors) ? response.data.errors.slice(0, 3).join(' | ') : '';
        await Swal.fire('Error', errs ? `${msg}. ${errs}` : msg, 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Bulk upload failed', 'error');
    } finally {
      setUploadingBulk(false);
    }
  };

  const handleEditInput = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const closeAddClientModal = () => {
    setShowAddClientModal(false);
    setSelectedClientOption(null);
    setAddClientForm({
      clientName: '',
      clientId: '',
      contractName: '',
      contractNo: '',
      contractCode: '',
      startDate: '',
      endDate: '',
      anchorName: '',
      anchorEmailId: '',
      anchorMobileNo: ''
    });
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEditingId(0);
    setSelectedEditClientOption(null);
    setEditForm({
      clientName: '',
      clientId: '',
      contractName: '',
      contractNo: '',
      contractCode: '',
      startDate: '',
      endDate: '',
      anchorName: '',
      anchorEmailId: '',
      anchorMobileNo: ''
    });
  };

  const validateMandatoryFields = (formValues) => {
    return (
      formValues.clientName &&
      formValues.clientId &&
      formValues.contractName &&
      formValues.contractNo &&
      formValues.contractCode &&
      formValues.startDate &&
      formValues.endDate &&
      formValues.anchorName &&
      formValues.anchorEmailId &&
      formValues.anchorMobileNo
    );
  };

  const closeAddComplianceModal = () => {
    setShowAddComplianceModal(false);
    setSelectedComplianceCompanyOption(null);
    setComplianceForm({
      companyName: '',
      licenseParticular: '',
      clientName: '',
      location: '',
      stateName: '',
      registrationNo: '',
      startDate: '',
      renewalDate: ''
    });
  };

  const closeComplianceBulkModal = () => {
    setShowComplianceBulkModal(false);
    setComplianceBulkFile(null);
  };

  const closeComplianceBulkResultModal = () => {
    setShowComplianceBulkResultModal(false);
    setBulkResultTab('added');
    setComplianceBulkResult({
      inserted: 0,
      failed: 0,
      alreadyInDatabase: 0,
      addedRows: [],
      rejectedRows: [],
      alreadyRows: []
    });
  };

  const closeEditComplianceModal = () => {
    setShowEditComplianceModal(false);
    setEditingComplianceId(0);
    setEditComplianceForm({
      companyName: '',
      licenseParticular: '',
      clientName: '',
      location: '',
      stateName: '',
      registrationNo: '',
      startDate: '',
      renewalDate: ''
    });
  };

  const handleComplianceInput = (e) => {
    const { name, value } = e.target;
    setComplianceForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditComplianceInput = (e) => {
    const { name, value } = e.target;
    setEditComplianceForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const openEditComplianceModal = (row) => {
    setEditingComplianceId(Number(row.id || 0));
    setEditComplianceForm({
      companyName: row.company_name || '',
      licenseParticular: row.license_particular || '',
      clientName: row.client_name || '',
      location: row.location || '',
      stateName: row.state_name || '',
      registrationNo: row.registration_no || '',
      startDate: row.start_date || '',
      renewalDate: row.renewal_date || ''
    });
    setShowEditComplianceModal(true);
  };

  const handleAddComplianceSubmit = async (e) => {
    e.preventDefault();
    if (
      !complianceForm.companyName ||
      !complianceForm.licenseParticular ||
      !complianceForm.clientName ||
      !complianceForm.location ||
      !complianceForm.stateName
    ) {
      await Swal.fire('Warning', 'Please fill all mandatory fields.', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('action', 'add_compliance');
    formData.append('company_name', complianceForm.companyName);
    formData.append('license_particular', complianceForm.licenseParticular);
    formData.append('client_name', complianceForm.clientName);
    formData.append('location', complianceForm.location);
    formData.append('state_name', complianceForm.stateName);
    formData.append('registration_no', complianceForm.registrationNo);
    formData.append('start_date', complianceForm.startDate);
    formData.append('renewal_date', complianceForm.renewalDate);

    try {
      setSavingCompliance(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status === true) {
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response?.data?.message || 'Compliance record added successfully',
          showConfirmButton: false,
          timer: 1500
        });
        closeAddComplianceModal();
        setCompliancePage(1);
        await fetchComplianceRecords(1, debouncedComplianceSearch);
      } else {
        await Swal.fire('Error', response?.data?.message || 'Failed to add compliance record', 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Failed to add compliance record', 'error');
    } finally {
      setSavingCompliance(false);
    }
  };

  const downloadComplianceDemoCsv = () => {
    const headers = [
      'company_name',
      'license_particular',
      'client_name',
      'location',
      'state',
      'registration_no',
      'start_date',
      'renewal_date'
    ];
    const sample = [
      'Meraqui Ventures',
      'CLRA License',
      'Reliance/ Qwick Supply',
      'Nandyal, Andhra Pradesh',
      'Andhra Pradesh',
      "'114261050000085",
      'YYYY-MM-DD',
      'YYYY-MM-DD'
    ];
    const csv = `${headers.join(',')}\n${sample.map((v) => {
      const text = String(v ?? '');
      if (text.includes(',') || text.includes('"') || text.includes('\n')) {
        return `"${text.replace(/"/g, '""')}"`;
      }
      return text;
    }).join(',')}\n`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'compliance_bulk_demo.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleComplianceBulkUpload = async () => {
    if (!complianceBulkFile) {
      await Swal.fire('Warning', 'Please select CSV file first.', 'warning');
      return;
    }

    const fileName = (complianceBulkFile.name || '').toLowerCase();
    if (!fileName.endsWith('.csv')) {
      await Swal.fire('Error', 'Only CSV file is allowed.', 'error');
      return;
    }

    const confirm = await Swal.fire({
      title: 'Upload compliance CSV?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, upload',
      cancelButtonText: 'Cancel'
    });
    if (!confirm.isConfirmed) return;

    const formData = new FormData();
    formData.append('action', 'bulk_upload_compliance');
    formData.append('csv_file', complianceBulkFile);

    try {
      setUploadingComplianceBulk(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status) {
        setComplianceBulkResult({
          inserted: Number(response?.data?.inserted || 0),
          failed: Number(response?.data?.failed || 0),
          alreadyInDatabase: Number(response?.data?.already_in_database || 0),
          addedRows: Array.isArray(response?.data?.added_rows) ? response.data.added_rows : [],
          rejectedRows: Array.isArray(response?.data?.rejected_rows) ? response.data.rejected_rows : [],
          alreadyRows: Array.isArray(response?.data?.already_rows) ? response.data.already_rows : []
        });
        setBulkResultTab('added');
        closeComplianceBulkModal();
        setShowComplianceBulkResultModal(true);
        setCompliancePage(1);
        await fetchComplianceRecords(1, debouncedComplianceSearch);
        await fetchComplianceCompanies();
      } else {
        const msg = response?.data?.message || 'Bulk upload failed';
        const errs = Array.isArray(response?.data?.errors) ? response.data.errors.slice(0, 3).join(' | ') : '';
        await Swal.fire('Error', errs ? `${msg}. ${errs}` : msg, 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Bulk upload failed', 'error');
    } finally {
      setUploadingComplianceBulk(false);
    }
  };

  const handleEditComplianceSubmit = async (e) => {
    e.preventDefault();
    if (
      !editComplianceForm.companyName ||
      !editComplianceForm.licenseParticular ||
      !editComplianceForm.clientName ||
      !editComplianceForm.location ||
      !editComplianceForm.stateName
    ) {
      await Swal.fire('Warning', 'Please fill all mandatory fields.', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('action', 'update_compliance');
    formData.append('id', String(editingComplianceId));
    formData.append('company_name', editComplianceForm.companyName);
    formData.append('license_particular', editComplianceForm.licenseParticular);
    formData.append('client_name', editComplianceForm.clientName);
    formData.append('location', editComplianceForm.location);
    formData.append('state_name', editComplianceForm.stateName);
    formData.append('registration_no', editComplianceForm.registrationNo);
    formData.append('start_date', editComplianceForm.startDate);
    formData.append('renewal_date', editComplianceForm.renewalDate);

    try {
      setSavingComplianceEdit(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status === true) {
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response?.data?.message || 'Compliance record updated successfully',
          showConfirmButton: false,
          timer: 1500
        });
        closeEditComplianceModal();
        await fetchComplianceRecords(compliancePage, debouncedComplianceSearch);
      } else {
        await Swal.fire('Error', response?.data?.message || 'Failed to update compliance record', 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Failed to update compliance record', 'error');
    } finally {
      setSavingComplianceEdit(false);
    }
  };

  const handleAddClientSubmit = async (e) => {
    e.preventDefault();
    if (!addClientForm.clientId) {
      await Swal.fire('Warning', 'Please select client first.', 'warning');
      return;
    }
    if (!validateMandatoryFields(addClientForm)) {
      await Swal.fire('Warning', 'Please fill all mandatory fields.', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('action', 'add_internal');
    formData.append('client_name', addClientForm.clientName);
    formData.append('staffinggo_client_id', addClientForm.clientId);
    formData.append('contract_name', addClientForm.contractName);
    formData.append('contract_no', addClientForm.contractNo);
    formData.append('contract_code', addClientForm.contractCode);
    formData.append('start_date', addClientForm.startDate);
    formData.append('end_date', addClientForm.endDate);
    formData.append('client_anchor_name', addClientForm.anchorName);
    formData.append('client_anchor_email_id', addClientForm.anchorEmailId);
    formData.append('anchor_mobile_no', addClientForm.anchorMobileNo);

    try {
      setSavingInternal(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status === true) {
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response?.data?.message || 'Contract added successfully',
          showConfirmButton: false,
          timer: 1500
        });
        closeAddClientModal();
        setPage(1);
        await fetchClientContracts(1, false, debouncedSearch);
      } else {
        await Swal.fire('Error', response?.data?.message || 'Failed to add internal contract', 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Failed to add internal contract', 'error');
    } finally {
      setSavingInternal(false);
    }
  };

  const openEditModal = (row) => {
    setEditingId(Number(row.id || 0));
    setEditForm({
      clientName: row.client || '',
      clientId: row.staffinggo_client_id ? String(row.staffinggo_client_id) : '',
      contractName: row.contract_name || row.contract || '',
      contractNo: row.contract_no || '',
      contractCode: row.contract_code || '',
      startDate: row.start_date || '',
      endDate: row.end_date || '',
      anchorName: row.anchor_name || '',
      anchorEmailId: row.anchor_email_id || '',
      anchorMobileNo: row.anchor_mobile_no || ''
    });

    const matched = externalClientOptions.find(
      (opt) => String(opt.clientId) === String(row.staffinggo_client_id || '')
    ) || null;
    setSelectedEditClientOption(matched);
    setShowEditModal(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editingId) return;
    if (!editForm.clientId) {
      await Swal.fire('Warning', 'Please select client first.', 'warning');
      return;
    }
    if (!validateMandatoryFields(editForm)) {
      await Swal.fire('Warning', 'Please fill all mandatory fields.', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('action', 'update_contract');
    formData.append('id', String(editingId));
    formData.append('client_name', editForm.clientName);
    formData.append('staffinggo_client_id', editForm.clientId);
    formData.append('contract_name', editForm.contractName);
    formData.append('contract_no', editForm.contractNo);
    formData.append('contract_code', editForm.contractCode);
    formData.append('start_date', editForm.startDate);
    formData.append('end_date', editForm.endDate);
    formData.append('client_anchor_name', editForm.anchorName);
    formData.append('client_anchor_email_id', editForm.anchorEmailId);
    formData.append('anchor_mobile_no', editForm.anchorMobileNo);

    try {
      setSavingEdit(true);
      const response = await axios.post(`${apiurl}license_registration.php`, formData);
      if (response?.data?.status === true) {
        await Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response?.data?.message || 'Contract updated successfully',
          showConfirmButton: false,
          timer: 1500
        });
        closeEditModal();
        await fetchClientContracts(page, false, debouncedSearch);
      } else {
        await Swal.fire('Error', response?.data?.message || 'Failed to update contract', 'error');
      }
    } catch (error) {
      await Swal.fire('Error', 'Failed to update contract', 'error');
    } finally {
      setSavingEdit(false);
    }
  };

  const getPageButtons = () => {
    if (totalPages <= 1) return [];
    const maxVisible = 5;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    const pages = [];
    for (let p = start; p <= end; p++) pages.push(p);
    return pages;
  };

  const getCompliancePageButtons = () => {
    if (complianceTotalPages <= 1) return [];
    const maxVisible = 5;
    let start = Math.max(1, compliancePage - 2);
    let end = Math.min(complianceTotalPages, start + maxVisible - 1);
    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }
    const pages = [];
    for (let p = start; p <= end; p++) pages.push(p);
    return pages;
  };

  const renderComplianceBulkTable = (rows, { showLicenseId = false, showReason = false, keyPrefix = 'rows' } = {}) => (
    <div style={{ maxHeight: '360px', overflow: 'auto', border: '1px solid #e5e7eb', borderRadius: '0.75rem' }}>
      <table className="table table-sm table-bordered mb-0 text-nowrap">
        <thead style={{ backgroundColor: '#f8f9fa' }}>
          <tr>
            <th>Line</th>
            {showLicenseId && <th>License ID</th>}
            <th>Company</th>
            <th>License/Particular</th>
            <th>Client</th>
            <th>Location</th>
            <th>State</th>
            <th>Registration No</th>
            <th>Start Date</th>
            <th>Renewal Date</th>
            {showReason && <th>Reason</th>}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((item, idx) => (
              <tr key={`${keyPrefix}-${idx}-${item.line_no || idx}`}>
                <td>{item.line_no || '-'}</td>
                {showLicenseId && <td>{item.license_id || '-'}</td>}
                <td>{item?.row?.company_name || '-'}</td>
                <td>{item?.row?.license_particular || '-'}</td>
                <td>{item?.row?.client_name || '-'}</td>
                <td>{item?.row?.location || '-'}</td>
                <td>{item?.row?.state || '-'}</td>
                <td>{item?.row?.registration_no || '-'}</td>
                <td>{item?.row?.start_date || '-'}</td>
                <td>{item?.row?.renewal_date || '-'}</td>
                {showReason && <td>{item.reason || '-'}</td>}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={1 + (showLicenseId ? 1 : 0) + 8 + (showReason ? 1 : 0)} className="text-center text-muted py-3">
                No rows
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  const renderContractsBulkTable = (rows, { showContractId = false, showReason = false, keyPrefix = 'rows' } = {}) => (
    <div style={{ maxHeight: '360px', overflow: 'auto', border: '1px solid #e5e7eb', borderRadius: '0.75rem' }}>
      <table className="table table-sm table-bordered mb-0 text-nowrap">
        <thead style={{ backgroundColor: '#f8f9fa' }}>
          <tr>
            <th>Line</th>
            {showContractId && <th>Contract ID</th>}
            <th>Client ID</th>
            <th>Client</th>
            <th>Contract Name</th>
            <th>Contract No</th>
            <th>Contract Code</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Anchor Name</th>
            <th>Anchor Email</th>
            <th>Anchor Mobile</th>
            {showReason && <th>Reason</th>}
          </tr>
        </thead>
        <tbody>
          {rows.length > 0 ? (
            rows.map((item, idx) => (
              <tr key={`${keyPrefix}-${idx}-${item.line_no || idx}`}>
                <td>{item.line_no || '-'}</td>
                {showContractId && <td>{item.staffinggo_contract_id || '-'}</td>}
                <td>{item?.row?.client_id || '-'}</td>
                <td>{item?.row?.client_name || '-'}</td>
                <td>{item?.row?.contract_name || '-'}</td>
                <td>{item?.row?.contract_no || '-'}</td>
                <td>{item?.row?.contract_code || '-'}</td>
                <td>{item?.row?.start_date || '-'}</td>
                <td>{item?.row?.end_date || '-'}</td>
                <td>{item?.row?.anchor_name || '-'}</td>
                <td>{item?.row?.anchor_email_id || '-'}</td>
                <td>{item?.row?.anchor_mobile_no || '-'}</td>
                {showReason && <td>{item.reason || '-'}</td>}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={1 + (showContractId ? 1 : 0) + 10 + (showReason ? 1 : 0)} className="text-center text-muted py-3">
                No rows
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="container-fluid py-4">
      <div className="card custom-card">
        <div className="card-body" style={{ overflow: 'hidden' }}>
          <ul className="nav mb-3" role="tablist" style={{ borderBottom: '1px solid #dfe3eb' }}>
            <li className="nav-item" role="presentation">
              {!isComplianceManager && (
                <button
                  className="nav-link"
                  id="client-contracts-tab"
                  type="button"
                  role="tab"
                  aria-controls="client-contracts"
                  aria-selected={activeTab === 'client-contracts'}
                  onClick={() => setActiveTab('client-contracts')}
                  style={
                    activeTab === 'client-contracts'
                      ? { ...tabButtonBaseStyle, color: 'var(--primary-color)', borderBottom: '3px solid var(--primary-color)' }
                      : { ...tabButtonBaseStyle, color: '#495057' }
                  }
                >
                  <i className="bx bx-file me-2" style={{ fontSize: '1.1rem', verticalAlign: 'middle' }}></i>
                  Client Contracts
                </button>
              )}
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="compliance-tab"
                type="button"
                role="tab"
                aria-controls="compliance"
                aria-selected={activeTab === 'compliance'}
                onClick={() => setActiveTab('compliance')}
                style={
                  activeTab === 'compliance'
                    ? { ...tabButtonBaseStyle, color: 'var(--primary-color)', borderBottom: '3px solid var(--primary-color)' }
                    : { ...tabButtonBaseStyle, color: '#495057' }
                }
              >
                <i className="bx bx-badge-check me-2" style={{ fontSize: '1.1rem', verticalAlign: 'middle' }}></i>
                Compliance
              </button>
            </li>
          </ul>

          <div className="tab-content">
            {!isComplianceManager && (
            <div
              className={`tab-pane fade ${activeTab === 'client-contracts' ? 'show active' : ''}`}
              id="client-contracts"
              role="tabpanel"
              aria-labelledby="client-contracts-tab"
            >
              <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <h3 className="mb-0 fw-bold text-lg" style={sectionHeadingStyle}>Client Contracts</h3>
                  <div style={{ width: '460px', maxWidth: '100%' }}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search client / contract / code / anchor / IDs"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setSearchInput('');
                          setPage(1);
                        }}
                        disabled={!searchInput}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <div className="d-flex gap-2 align-items-center flex-wrap justify-content-end">
                    <button type="button" className="btn btn-primary-light" onClick={() => setShowBulkModal(true)}>
                      Bulk Upload
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => setShowAddClientModal(true)}
                    >
                      Add Client Contracts
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleFetchClients}
                      disabled={fetchingClients || loadingContracts}
                    >
                      {fetchingClients ? 'Fetching...' : 'Fetch Clients'}
                    </button>
                  </div>
                  <small className="text-muted mt-1">Last extracted: {formatLastExtracted(lastExtractedAt)}</small>
                </div>
              </div>
              <div className="d-flex gap-3 align-items-center mb-2 flex-wrap">
                <small className="text-muted">
                  <span className="badge me-1" style={{ backgroundColor: '#fff2df', color: '#a25900' }}>Soon Expiring</span>
                  (within 2 months)
                </small>
                <small className="text-muted">
                  <span className="badge me-1" style={{ backgroundColor: '#ffe5e5', color: '#a02828' }}>Expired</span>
                  (date already passed)
                </small>
              </div>

              <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
                <table className="table table-bordered mb-0 align-middle text-nowrap" style={{ width: 'max-content', minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '70px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Sr no.</th>
                      <th style={{ minWidth: '170px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Client</th>
                      <th style={{ minWidth: '170px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Contract</th>
                      <th style={{ width: '140px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Contract no</th>
                      <th style={{ width: '130px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Contract code</th>
                      <th style={{ width: '120px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Start date</th>
                      <th style={{ width: '120px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>End date</th>
                      <th style={{ minWidth: '160px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Anchor name</th>
                      <th style={{ minWidth: '220px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Anchor email id</th>
                      <th style={{ width: '110px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingContracts ? (
                      <tr>
                        <td colSpan="10" className="text-center text-muted">Loading...</td>
                      </tr>
                    ) : contracts.length > 0 ? (
                      contracts.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>{item.sr_no || (index + 1)}</td>
                          <td>{item.client || '-'}</td>
                          <td>{item.contract || '-'}</td>
                          <td>{item.contract_no || '-'}</td>
                          <td>{item.contract_code || '-'}</td>
                          <td>{item.start_date || '-'}</td>
                          <td style={getExpiryHighlightStyle(item.end_date)}>{item.end_date || '-'}</td>
                          <td>{item.anchor_name || '-'}</td>
                          <td>{item.anchor_email_id || '-'}</td>
                          <td className="text-center">
                            <button type="button" className="btn btn-sm btn-primary-light" onClick={() => openEditModal(item)}>Edit</button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center text-muted">{contractsError || 'No records found'}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                <div className="text-muted">
                  {totalRecords > 0
                    ? `Showing ${(page - 1) * limit + 1} to ${Math.min(page * limit, totalRecords)} of ${totalRecords}`
                    : 'No records'}
                </div>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-light px-3 py-2" disabled={page <= 1 || loadingContracts} onClick={() => changePage(1)}>First</button>
                  <button type="button" className="btn btn-light px-3 py-2" disabled={page <= 1 || loadingContracts} onClick={() => changePage(page - 1)}>Prev</button>
                  {getPageButtons().map((p) => (
                    <button key={p} type="button" className={`btn px-3 py-2 ${p === page ? 'btn-primary' : 'btn-light'}`} onClick={() => changePage(p)} disabled={loadingContracts}>{p}</button>
                  ))}
                  <button type="button" className="btn btn-light px-3 py-2" disabled={page >= totalPages || loadingContracts || totalPages === 0} onClick={() => changePage(page + 1)}>Next</button>
                  <button type="button" className="btn btn-light px-3 py-2" disabled={page >= totalPages || loadingContracts || totalPages === 0} onClick={() => changePage(totalPages)}>Last</button>
                </div>
              </div>
            </div>
            )}

            <div
              className={`tab-pane fade ${activeTab === 'compliance' ? 'show active' : ''}`}
              id="compliance"
              role="tabpanel"
              aria-labelledby="compliance-tab"
            >
              <div className="d-flex justify-content-between align-items-start mb-2 flex-wrap gap-2">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <h3 className="mb-0 fw-bold text-lg" style={sectionHeadingStyle}>Compliance</h3>
                  <div style={{ width: '460px', maxWidth: '100%' }}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search license / client / state / location"
                        value={complianceSearchInput}
                        onChange={(e) => setComplianceSearchInput(e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setComplianceSearchInput('');
                          setCompliancePage(1);
                        }}
                        disabled={!complianceSearchInput}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <div className="d-flex gap-2 align-items-center flex-wrap justify-content-end">
                    <button type="button" className="btn btn-primary-light" onClick={() => setShowComplianceBulkModal(true)}>
                      Bulk Upload
                    </button>
                    <button type="button" className="btn btn-primary" onClick={() => setShowAddComplianceModal(true)}>
                      Add Licences
                    </button>
                  </div>
                  <small className="text-muted mt-1" style={{ visibility: 'hidden' }}>Last extracted: --</small>
                </div>
              </div>
              <div className="d-flex gap-3 align-items-center mb-2 flex-wrap">
                <small className="text-muted">
                  <span className="badge me-1" style={{ backgroundColor: '#fff2df', color: '#a25900' }}>Soon Expiring</span>
                  (within 2 months)
                </small>
                <small className="text-muted">
                  <span className="badge me-1" style={{ backgroundColor: '#ffe5e5', color: '#a02828' }}>Expired</span>
                  (date already passed)
                </small>
              </div>

              {loadingCompliance ? (
                <div
                  className="d-flex flex-column align-items-center justify-content-center rounded border"
                  style={{ minHeight: '320px', background: 'linear-gradient(180deg, #f8fafe 0%, #ffffff 100%)' }}
                >
                  <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="mt-3 fw-semibold text-muted">Fetching compliance records...</div>
                </div>
              ) : (
                <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
                  <table className="table table-bordered mb-0 align-middle text-nowrap" style={{ width: 'max-content', minWidth: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '70px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Sr no.</th>
                        <th style={{ minWidth: '170px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Company Name</th>
                        <th style={{ minWidth: '170px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>License/Particular's</th>
                        <th style={{ minWidth: '170px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Client Name</th>
                        <th style={{ minWidth: '180px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Location</th>
                        <th style={{ minWidth: '130px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>State</th>
                        <th style={{ minWidth: '210px', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Registration No</th>
                        <th style={{ width: '120px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Start Date</th>
                        <th style={{ width: '130px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Renewal Date</th>
                        <th style={{ width: '110px', whiteSpace: 'nowrap', backgroundColor: 'var(--primary-color)', color: '#fff' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {complianceRows.length > 0 ? (
                        complianceRows.map((item, index) => (
                          <tr key={item.id || index}>
                            <td>{item.sr_no || (index + 1)}</td>
                            <td>{item.company_name || '-'}</td>
                            <td>{item.license_particular || '-'}</td>
                            <td>{item.client_name || '-'}</td>
                            <td>{item.location || '-'}</td>
                            <td>{item.state_name || '-'}</td>
                            <td>{item.registration_no || '-'}</td>
                            <td>{item.start_date || '-'}</td>
                            <td style={getExpiryHighlightStyle(item.renewal_date)}>{item.renewal_date || '-'}</td>
                            <td className="text-center">
                              <button type="button" className="btn btn-sm btn-primary-light" onClick={() => openEditComplianceModal(item)}>Edit</button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center text-muted">{complianceError || 'No records found'}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                <div className="text-muted">
                  {complianceTotalRecords > 0
                    ? `Showing ${(compliancePage - 1) * limit + 1} to ${Math.min(compliancePage * limit, complianceTotalRecords)} of ${complianceTotalRecords}`
                    : 'No records'}
                </div>
                <div className="d-flex align-items-center gap-1">
                  <button type="button" className="btn btn-light px-3 py-2" disabled={compliancePage <= 1 || loadingCompliance} onClick={() => changeCompliancePage(1)}>First</button>
                  <button type="button" className="btn btn-light px-3 py-2" disabled={compliancePage <= 1 || loadingCompliance} onClick={() => changeCompliancePage(compliancePage - 1)}>Prev</button>
                  {getCompliancePageButtons().map((p) => (
                    <button key={p} type="button" className={`btn px-3 py-2 ${p === compliancePage ? 'btn-primary' : 'btn-light'}`} onClick={() => changeCompliancePage(p)} disabled={loadingCompliance}>{p}</button>
                  ))}
                  <button type="button" className="btn btn-light px-3 py-2" disabled={compliancePage >= complianceTotalPages || loadingCompliance || complianceTotalPages === 0} onClick={() => changeCompliancePage(compliancePage + 1)}>Next</button>
                  <button type="button" className="btn btn-light px-3 py-2" disabled={compliancePage >= complianceTotalPages || loadingCompliance || complianceTotalPages === 0} onClick={() => changeCompliancePage(complianceTotalPages)}>Last</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showBulkModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Bulk Upload Internal Contracts</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeBulkModal}></button>
                </div>
                <div className="modal-body">
                  <div className="p-3 rounded border mb-3" style={{ background: 'rgba(var(--primary-rgb), 0.04)' }}>
                    <p className="mb-2 fw-semibold">Step 1: Download Demo CSV</p>
                    <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                      Use this template. Keep all mandatory columns and date format as `YYYY-MM-DD` (example: `2026-03-01`).
                    </p>
                    <div className="d-flex gap-2 flex-wrap">
                      <button type="button" className="btn btn-primary-light" onClick={downloadDemoCsv}>
                        <i className="bx bx-download me-1"></i> Download Demo CSV
                      </button>
                      <button type="button" className="btn btn-primary" onClick={downloadClientList}>
                        <i className="bx bx-spreadsheet me-1"></i> Download Client List
                      </button>
                    </div>
                    {/* <small className="text-muted d-block mt-2">
                      Note: This `client_id` should be from the client list file.
                    </small> */}
                  </div>

                  <div className="p-3 rounded border" style={{ background: '#fff' }}>
                    <p className="mb-2 fw-semibold">Step 2: Upload CSV File</p>
                    <input
                      type="file"
                      className="form-control"
                      accept=".csv,text/csv"
                      onChange={(e) => setBulkFile(e.target.files?.[0] || null)}
                    />
                    <small className="text-muted d-block mt-2">
                      Only `.csv` file is allowed.
                    </small>
                    {bulkFile && (
                      <small className="d-block mt-2 text-success">
                        Selected: {bulkFile.name}
                      </small>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={closeBulkModal} disabled={uploadingBulk}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleBulkUpload} disabled={uploadingBulk}>
                    {uploadingBulk ? 'Uploading...' : 'Upload CSV'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showBulkResultModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Client Contracts Bulk Upload Summary</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeBulkResultModal}></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex gap-2 flex-wrap mb-3">
                    <span className="badge bg-success">Added: {bulkUploadResult.inserted}</span>
                    <span className="badge bg-danger">Rejected: {bulkUploadResult.failed}</span>
                    <span className="badge bg-warning text-dark">Already in DB: {bulkUploadResult.alreadyInDatabase}</span>
                  </div>

                  <div className="d-flex flex-wrap gap-2 mb-3" style={{ borderBottom: '1px solid #e9edf4', paddingBottom: '0.65rem' }}>
                    <button
                      type="button"
                      className={`btn ${bulkResultTabContracts === 'added' ? 'btn-success' : 'btn-light'}`}
                      onClick={() => setBulkResultTabContracts('added')}
                      style={{ minWidth: '180px', fontWeight: 600 }}
                    >
                      Added ({bulkUploadResult.addedRows.length})
                    </button>
                    <button
                      type="button"
                      className={`btn ${bulkResultTabContracts === 'rejected' ? 'btn-danger' : 'btn-light'}`}
                      onClick={() => setBulkResultTabContracts('rejected')}
                      style={{ minWidth: '180px', fontWeight: 600 }}
                    >
                      Rejected ({bulkUploadResult.rejectedRows.length})
                    </button>
                    <button
                      type="button"
                      className={`btn ${bulkResultTabContracts === 'already' ? 'btn-warning text-dark' : 'btn-light'}`}
                      onClick={() => setBulkResultTabContracts('already')}
                      style={{ minWidth: '220px', fontWeight: 600 }}
                    >
                      Already in Database ({bulkUploadResult.alreadyRows.length})
                    </button>
                  </div>

                  {bulkResultTabContracts === 'added' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-success">Added Rows</h6>
                      {renderContractsBulkTable(bulkUploadResult.addedRows, {
                        showContractId: true,
                        showReason: false,
                        keyPrefix: 'contracts-added'
                      })}
                    </div>
                  )}

                  {bulkResultTabContracts === 'rejected' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-danger">Rejected Rows</h6>
                      {renderContractsBulkTable(bulkUploadResult.rejectedRows, {
                        showContractId: false,
                        showReason: true,
                        keyPrefix: 'contracts-rejected'
                      })}
                    </div>
                  )}

                  {bulkResultTabContracts === 'already' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-warning">Already In Database Rows</h6>
                      {renderContractsBulkTable(bulkUploadResult.alreadyRows, {
                        showContractId: true,
                        showReason: true,
                        keyPrefix: 'contracts-already'
                      })}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={closeBulkResultModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showComplianceBulkModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Bulk Upload Compliance</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeComplianceBulkModal}></button>
                </div>
                <div className="modal-body">
                  <div className="p-3 rounded border mb-3" style={{ background: 'rgba(var(--primary-rgb), 0.04)' }}>
                    <p className="mb-2 fw-semibold">Step 1: Download Demo CSV</p>
                    <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                      Use this template. Keep all mandatory columns and date format as `YYYY-MM-DD` (example: `2026-03-01`).
                    </p>
                    <button type="button" className="btn btn-primary" onClick={downloadComplianceDemoCsv}>
                      <i className="bx bx-download me-1"></i> Download Demo CSV
                    </button>
                  </div>

                  <div className="p-3 rounded border" style={{ background: '#fff' }}>
                    <p className="mb-2 fw-semibold">Step 2: Upload CSV File</p>
                    <input
                      type="file"
                      className="form-control"
                      accept=".csv,text/csv"
                      onChange={(e) => setComplianceBulkFile(e.target.files?.[0] || null)}
                    />
                    <small className="text-muted d-block mt-2">Only `.csv` file is allowed.</small>
                    {complianceBulkFile && (
                      <small className="d-block mt-2 text-success">Selected: {complianceBulkFile.name}</small>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-light" onClick={closeComplianceBulkModal} disabled={uploadingComplianceBulk}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleComplianceBulkUpload} disabled={uploadingComplianceBulk}>
                    {uploadingComplianceBulk ? 'Uploading...' : 'Upload CSV'}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showComplianceBulkResultModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-xl modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Compliance Bulk Upload Summary</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeComplianceBulkResultModal}></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex gap-2 flex-wrap mb-3">
                    <span className="badge bg-success">Added: {complianceBulkResult.inserted}</span>
                    <span className="badge bg-danger">Rejected: {complianceBulkResult.failed}</span>
                    <span className="badge bg-warning text-dark">Already in DB: {complianceBulkResult.alreadyInDatabase}</span>
                  </div>

                  <div className="d-flex flex-wrap gap-2 mb-3" style={{ borderBottom: '1px solid #e9edf4', paddingBottom: '0.65rem' }}>
                    <button
                      type="button"
                      className={`btn ${bulkResultTab === 'added' ? 'btn-success' : 'btn-light'}`}
                      onClick={() => setBulkResultTab('added')}
                      style={{ minWidth: '180px', fontWeight: 600 }}
                    >
                      Added ({complianceBulkResult.addedRows.length})
                    </button>
                    <button
                      type="button"
                      className={`btn ${bulkResultTab === 'rejected' ? 'btn-danger' : 'btn-light'}`}
                      onClick={() => setBulkResultTab('rejected')}
                      style={{ minWidth: '180px', fontWeight: 600 }}
                    >
                      Rejected ({complianceBulkResult.rejectedRows.length})
                    </button>
                    <button
                      type="button"
                      className={`btn ${bulkResultTab === 'already' ? 'btn-warning text-dark' : 'btn-light'}`}
                      onClick={() => setBulkResultTab('already')}
                      style={{ minWidth: '220px', fontWeight: 600 }}
                    >
                      Already in Database ({complianceBulkResult.alreadyRows.length})
                    </button>
                  </div>

                  {bulkResultTab === 'added' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-success">Added Rows</h6>
                      {renderComplianceBulkTable(complianceBulkResult.addedRows, {
                        showLicenseId: true,
                        showReason: false,
                        keyPrefix: 'added'
                      })}
                    </div>
                  )}

                  {bulkResultTab === 'rejected' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-danger">Rejected Rows</h6>
                      {renderComplianceBulkTable(complianceBulkResult.rejectedRows, {
                        showLicenseId: false,
                        showReason: true,
                        keyPrefix: 'rejected'
                      })}
                    </div>
                  )}

                  {bulkResultTab === 'already' && (
                    <div>
                      <h6 className="fw-bold mb-2 text-warning">Already In Database Rows</h6>
                      {renderComplianceBulkTable(complianceBulkResult.alreadyRows, {
                        showLicenseId: true,
                        showReason: true,
                        keyPrefix: 'already'
                      })}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={closeComplianceBulkResultModal}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showAddComplianceModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Licences</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeAddComplianceModal}></button>
                </div>
                <form onSubmit={handleAddComplianceSubmit}>
                  <div className="modal-body">
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Company Name <span className="text-danger">*</span></label>
                        <Select
                          classNamePrefix="react-select"
                          options={complianceCompanyOptions}
                          value={selectedComplianceCompanyOption}
                          onChange={(option) => {
                            setSelectedComplianceCompanyOption(option);
                            setComplianceForm((prev) => ({
                              ...prev,
                              companyName: option?.value || ''
                            }));
                          }}
                          placeholder="Select company name"
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">License/Particular's <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="licenseParticular" value={complianceForm.licenseParticular} onChange={handleComplianceInput} placeholder="Enter license/particular" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Client Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="clientName" value={complianceForm.clientName} onChange={handleComplianceInput} placeholder="Enter client name" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Location <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="location" value={complianceForm.location} onChange={handleComplianceInput} placeholder="Enter location" required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">State <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="stateName" value={complianceForm.stateName} onChange={handleComplianceInput} placeholder="Enter state" required />
                      </div>
                      <div className="col-12 col-md-8">
                        <label className="form-label">Registration No</label>
                        <input type="text" className="form-control" name="registrationNo" value={complianceForm.registrationNo} onChange={handleComplianceInput} placeholder="Enter registration no" />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Start Date</label>
                        <input type="date" className="form-control" name="startDate" value={complianceForm.startDate} onChange={handleComplianceInput} />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Renewal Date</label>
                        <input type="date" className="form-control" name="renewalDate" value={complianceForm.renewalDate} onChange={handleComplianceInput} />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light" onClick={closeAddComplianceModal} disabled={savingCompliance}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={savingCompliance}>{savingCompliance ? 'Saving...' : 'Save'}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showEditComplianceModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Licence</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeEditComplianceModal}></button>
                </div>
                <form onSubmit={handleEditComplianceSubmit}>
                  <div className="modal-body">
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Company Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="companyName" value={editComplianceForm.companyName} onChange={handleEditComplianceInput} required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">License/Particular's <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="licenseParticular" value={editComplianceForm.licenseParticular} onChange={handleEditComplianceInput} required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Client Name <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="clientName" value={editComplianceForm.clientName} onChange={handleEditComplianceInput} required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Location <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="location" value={editComplianceForm.location} onChange={handleEditComplianceInput} required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">State <span className="text-danger">*</span></label>
                        <input type="text" className="form-control" name="stateName" value={editComplianceForm.stateName} onChange={handleEditComplianceInput} required />
                      </div>
                      <div className="col-12 col-md-8">
                        <label className="form-label">Registration No</label>
                        <input type="text" className="form-control" name="registrationNo" value={editComplianceForm.registrationNo} onChange={handleEditComplianceInput} />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Start Date</label>
                        <input type="date" className="form-control" name="startDate" value={editComplianceForm.startDate} onChange={handleEditComplianceInput} />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Renewal Date</label>
                        <input type="date" className="form-control" name="renewalDate" value={editComplianceForm.renewalDate} onChange={handleEditComplianceInput} />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light" onClick={closeEditComplianceModal} disabled={savingComplianceEdit}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={savingComplianceEdit}>{savingComplianceEdit ? 'Saving...' : 'Update'}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showAddClientModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Client Contracts</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeAddClientModal}></button>
                </div>
                <form onSubmit={handleAddClientSubmit}>
                  <div className="modal-body">
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Client</label>
                        <Select
                          classNamePrefix="react-select"
                          options={externalClientOptions}
                          value={selectedClientOption}
                          onChange={(option) => {
                            setSelectedClientOption(option);
                            setAddClientForm((prev) => ({
                              ...prev,
                              clientName: option?.clientName || '',
                              clientId: option?.clientId || ''
                            }));
                          }}
                          placeholder="Select client"
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Contract Name</label>
                        <input type="text" className="form-control" name="contractName" value={addClientForm.contractName} onChange={handleAddClientInput} placeholder="Enter contract name" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Contract No</label>
                        <input type="text" className="form-control" name="contractNo" value={addClientForm.contractNo} onChange={handleAddClientInput} placeholder="Enter contract no" required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">Contract Code</label>
                        <input type="text" className="form-control" name="contractCode" value={addClientForm.contractCode} onChange={handleAddClientInput} placeholder="Enter contract code" required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">Start Date</label>
                        <input type="date" className="form-control" name="startDate" value={addClientForm.startDate} onChange={handleAddClientInput} required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">End Date</label>
                        <input type="date" className="form-control" name="endDate" value={addClientForm.endDate} onChange={handleAddClientInput} required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Name</label>
                        <input type="text" className="form-control" name="anchorName" value={addClientForm.anchorName} onChange={handleAddClientInput} placeholder="Enter anchor name" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Mobile No</label>
                        <input type="text" className="form-control" name="anchorMobileNo" value={addClientForm.anchorMobileNo} onChange={handleAddClientInput} placeholder="Enter anchor mobile no" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Email ID</label>
                        <input type="email" className="form-control" name="anchorEmailId" value={addClientForm.anchorEmailId} onChange={handleAddClientInput} placeholder="Enter anchor email id" required />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light" onClick={closeAddClientModal} disabled={savingInternal}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={savingInternal}>{savingInternal ? 'Saving...' : 'Save'}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {showEditModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Client Contract</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeEditModal}></button>
                </div>
                <form onSubmit={handleEditSubmit}>
                  <div className="modal-body">
                    <div className="alert alert-light border mb-3 py-2">
                      <small className="mb-0 d-block">
                        Only <strong>Start Date</strong> and <strong>End Date</strong> are editable in this form.
                      </small>
                    </div>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Client</label>
                        <Select
                          classNamePrefix="react-select"
                          options={externalClientOptions}
                          value={selectedEditClientOption}
                          isDisabled
                          styles={{
                            control: (base) => ({
                              ...base,
                              backgroundColor: '#f1f3f7',
                              cursor: 'not-allowed'
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: '#6c757d'
                            })
                          }}
                          onChange={(option) => {
                            setSelectedEditClientOption(option);
                            setEditForm((prev) => ({
                              ...prev,
                              clientName: option?.clientName || '',
                              clientId: option?.clientId || ''
                            }));
                          }}
                          placeholder="Select client"
                          isClearable
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Contract Name</label>
                        <input type="text" className="form-control" style={readOnlyInputStyle} name="contractName" value={editForm.contractName} onChange={handleEditInput} readOnly required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Contract No</label>
                        <input type="text" className="form-control" style={readOnlyInputStyle} name="contractNo" value={editForm.contractNo} onChange={handleEditInput} readOnly required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">Contract Code</label>
                        <input type="text" className="form-control" style={readOnlyInputStyle} name="contractCode" value={editForm.contractCode} onChange={handleEditInput} readOnly required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label text-primary fw-semibold">Start Date (Editable)</label>
                        <input type="date" className="form-control" style={editableDateStyle} name="startDate" value={editForm.startDate} onChange={handleEditInput} required />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label text-primary fw-semibold">End Date (Editable)</label>
                        <input type="date" className="form-control" style={editableDateStyle} name="endDate" value={editForm.endDate} onChange={handleEditInput} required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Name</label>
                        <input type="text" className="form-control" style={readOnlyInputStyle} name="anchorName" value={editForm.anchorName} onChange={handleEditInput} readOnly required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Mobile No</label>
                        <input type="text" className="form-control" style={readOnlyInputStyle} name="anchorMobileNo" value={editForm.anchorMobileNo} onChange={handleEditInput} readOnly required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">Anchor Email ID</label>
                        <input type="email" className="form-control" style={readOnlyInputStyle} name="anchorEmailId" value={editForm.anchorEmailId} onChange={handleEditInput} readOnly required />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-light" onClick={closeEditModal} disabled={savingEdit}>Cancel</button>
                    <button type="submit" className="btn btn-primary" disabled={savingEdit}>{savingEdit ? 'Saving...' : 'Update'}</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
}

export default LicenseRegistration;
